var map = {
	"./app/reducers/language.js": 34206,
	"./component/empty/language.js": 18716,
	"./component/footer/language.js": 78516,
	"./component/header/language.js": 2150,
	"./component/notice/language.js": 7653,
	"./component/product/language.js": 67486,
	"./component/supplier/language.js": 64705,
	"./component/uploadComponent/language.js": 99959,
	"./pages/allocations/components/allocationDashboard/language.js": 76461,
	"./pages/allocations/components/allocationMarket/language.js": 16563,
	"./pages/allocations/components/allocationSuggest/language.js": 39263,
	"./pages/allocations/components/allocationsBase/language.js": 52025,
	"./pages/allocations/components/allocationsCenter/language.js": 12257,
	"./pages/allocations/language.js": 32323,
	"./pages/apply/language.js": 81110,
	"./pages/buyers/language.js": 30974,
	"./pages/cart/language.js": 11820,
	"./pages/company/address/components/language.js": 10141,
	"./pages/company/address/language.js": 76150,
	"./pages/company/aptitude/language.js": 98032,
	"./pages/company/category​/index/language.js": 62692,
	"./pages/company/change/language.js": 52490,
	"./pages/company/delivery/language.js": 63350,
	"./pages/company/detail/language.js": 29669,
	"./pages/company/index/language.js": 18282,
	"./pages/documents/components/Print/language.js": 97571,
	"./pages/documents/purchase/language.js": 37554,
	"./pages/documents/supplier/language.js": 21271,
	"./pages/favorites/language.js": 1073,
	"./pages/home/components/classify/center/language.js": 95001,
	"./pages/home/components/classify/left/language.js": 54529,
	"./pages/home/components/classify/right/language.js": 36764,
	"./pages/home/components/newProducts/language.js": 23785,
	"./pages/home/components/purchaseSchool/language.js": 44368,
	"./pages/home/components/recommendProducts/language.js": 99917,
	"./pages/home/components/recommendProductsItem/language.js": 31768,
	"./pages/home/components/searchInput/language.js": 60911,
	"./pages/home/index/language.js": 34150,
	"./pages/invitePro/language.js": 38310,
	"./pages/login/language.js": 6849,
	"./pages/logistics/language.js": 11983,
	"./pages/notice/language.js": 87438,
	"./pages/order/language.js": 10886,
	"./pages/plan/language.js": 53131,
	"./pages/product/language.js": 23971,
	"./pages/quote/main/language.js": 98750,
	"./pages/register/language.js": 43949,
	"./pages/registerResult/language.js": 75422,
	"./pages/retrieve/language.js": 29078,
	"./pages/role/components/roleInfo/language.js": 44996,
	"./pages/role/index/language.js": 29207,
	"./pages/school/detail/language.js": 98694,
	"./pages/school/list/language.js": 66725,
	"./pages/search/language.js": 27862,
	"./pages/sourcing/language.js": 79788,
	"./pages/sourcing/main/language.js": 78124,
	"./pages/staff/components/linkModal/language.js": 29765,
	"./pages/staff/components/resetPassword/language.js": 75692,
	"./pages/staff/components/staffInfo/language.js": 56544,
	"./pages/staff/examine/language.js": 55292,
	"./pages/staff/index/language.js": 85165,
	"./pages/staff/link/language.js": 75355,
	"./pages/supplierApply/language.js": 77974,
	"./pages/supplierCenter/language.js": 22081,
	"./pages/supplierKpi/language.js": 14332,
	"./pages/supplierManage/language.js": 37587,
	"./pages/supplierVerify/language.js": 45613,
	"app/reducers/language.js": 34206,
	"component/empty/language.js": 18716,
	"component/footer/language.js": 78516,
	"component/header/language.js": 2150,
	"component/notice/language.js": 7653,
	"component/product/language.js": 67486,
	"component/supplier/language.js": 64705,
	"component/uploadComponent/language.js": 99959,
	"pages/allocations/components/allocationDashboard/language.js": 76461,
	"pages/allocations/components/allocationMarket/language.js": 16563,
	"pages/allocations/components/allocationSuggest/language.js": 39263,
	"pages/allocations/components/allocationsBase/language.js": 52025,
	"pages/allocations/components/allocationsCenter/language.js": 12257,
	"pages/allocations/language.js": 32323,
	"pages/apply/language.js": 81110,
	"pages/buyers/language.js": 30974,
	"pages/cart/language.js": 11820,
	"pages/company/address/components/language.js": 10141,
	"pages/company/address/language.js": 76150,
	"pages/company/aptitude/language.js": 98032,
	"pages/company/category​/index/language.js": 62692,
	"pages/company/change/language.js": 52490,
	"pages/company/delivery/language.js": 63350,
	"pages/company/detail/language.js": 29669,
	"pages/company/index/language.js": 18282,
	"pages/documents/components/Print/language.js": 97571,
	"pages/documents/purchase/language.js": 37554,
	"pages/documents/supplier/language.js": 21271,
	"pages/favorites/language.js": 1073,
	"pages/home/components/classify/center/language.js": 95001,
	"pages/home/components/classify/left/language.js": 54529,
	"pages/home/components/classify/right/language.js": 36764,
	"pages/home/components/newProducts/language.js": 23785,
	"pages/home/components/purchaseSchool/language.js": 44368,
	"pages/home/components/recommendProducts/language.js": 99917,
	"pages/home/components/recommendProductsItem/language.js": 31768,
	"pages/home/components/searchInput/language.js": 60911,
	"pages/home/index/language.js": 34150,
	"pages/invitePro/language.js": 38310,
	"pages/login/language.js": 6849,
	"pages/logistics/language.js": 11983,
	"pages/notice/language.js": 87438,
	"pages/order/language.js": 10886,
	"pages/plan/language.js": 53131,
	"pages/product/language.js": 23971,
	"pages/quote/main/language.js": 98750,
	"pages/register/language.js": 43949,
	"pages/registerResult/language.js": 75422,
	"pages/retrieve/language.js": 29078,
	"pages/role/components/roleInfo/language.js": 44996,
	"pages/role/index/language.js": 29207,
	"pages/school/detail/language.js": 98694,
	"pages/school/list/language.js": 66725,
	"pages/search/language.js": 27862,
	"pages/sourcing/language.js": 79788,
	"pages/sourcing/main/language.js": 78124,
	"pages/staff/components/linkModal/language.js": 29765,
	"pages/staff/components/resetPassword/language.js": 75692,
	"pages/staff/components/staffInfo/language.js": 56544,
	"pages/staff/examine/language.js": 55292,
	"pages/staff/index/language.js": 85165,
	"pages/staff/link/language.js": 75355,
	"pages/supplierApply/language.js": 77974,
	"pages/supplierCenter/language.js": 22081,
	"pages/supplierKpi/language.js": 14332,
	"pages/supplierManage/language.js": 37587,
	"pages/supplierVerify/language.js": 45613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41336;